import API_BASE_URL from '../Config';

export const getGeneros = async (token) => {
    const response = await fetch(`${API_BASE_URL}/generos`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar géneros');
    return response.json();
};

export const getGenerosPaginadas = async (token, page = 0, size = 10, search = '') => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        search: search
    });

    const response = await fetch(`${API_BASE_URL}/generos/page?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar géneros paginados');
    return response.json();
};

export const getGeneroById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/generos/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el género');
    return response.json();
};

export const createGenero = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/generos`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el género');
    return response.json();
};

export const updateGenero = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/generos/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el género');
    return response.json();
};

export const darDeBajaGenero = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/generos/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja el género');
};

export const deleteGenero = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/generos/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar el género');
};
